import React from 'react';
import { Badge } from 'primereact/badge';
import MovieItem from './MovieItem';
import './MovieComponents.css';

const MovieList = ({ 
	movies, 
	title, 
	icon, 
	isInMachine, 
	onRemoveMovie, 
	onAddMovie, 
	onTypeChange,
	movieTypeOptions,
	emptyMessage = "Geen films beschikbaar",
	emptyIcon = "pi pi-video"
}) => {

	const moviesWithUrl = movies.filter(movie => movie.url);
	
	return (
		<div className="surface-0 border-1 border-200 border-round-lg overflow-hidden">
			{/* Header */}
			<div className="p-3 bg-primary-50 flex align-items-center justify-content-between">
				<h3 className="m-0 text-base font-semibold flex align-items-center gap-2">
					<i className={`${icon} text-primary`}></i>
					{title}
					{moviesWithUrl.length > 0 && (
						<Badge 
							value={moviesWithUrl.length} 
							severity={isInMachine ? "success" : "info"}
						/>
					)}
				</h3>
			</div>

			{/* Body */}
			<div className="p-3">
				{moviesWithUrl.length === 0 ? (
					<div className="text-center p-4 text-600">
						<i className={`${emptyIcon} text-4xl mb-2 block text-300`}></i>
						<p className="m-0">{emptyMessage}</p>
					</div>
				) : (
					<div className="grid">
						{movies.map((movie, index) => (
							movie.url && (
								<div key={movie.id || index} className="col-12 md:col-6">
									<MovieItem
										movie={movie}
										index={index}
										isInMachine={isInMachine}
										onRemove={onRemoveMovie}
										onAdd={onAddMovie}
										onTypeChange={onTypeChange}
										movieTypeOptions={movieTypeOptions}
										/>
								</div>
							)
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default MovieList;
